/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type HpRespPromoModuleSecondary_homepage$ref: FragmentReference;
export type HpRespPromoModuleSecondary_homepage = {|
  +promoSecondaryModule: ?{|
    +items?: ?$ReadOnlyArray<?{|
      +cmsId: ?number,
      +link: ?string,
      +alignment: ?string,
      +imageUrl?: ?string,
      +mobileImageUrl?: ?string,
    |}>
  |},
  +promoPrimaryModule: ?{|
    +totalItemsCount?: ?number
  |},
  +$refType: HpRespPromoModuleSecondary_homepage$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "HpRespPromoModuleSecondary_homepage",
  "type": "Homepage",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMobile",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "promoSecondaryModule",
      "name": "module",
      "storageKey": "module(type:\"promoSecondary\")",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "promoSecondary",
          "type": "String!"
        }
      ],
      "concreteType": null,
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "PromoModule",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": null,
              "args": null,
              "concreteType": "PromoItem",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "cmsId",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "link",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "alignment",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "Condition",
                  "passingValue": true,
                  "condition": "isMobile",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "mobileImageUrl",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "Condition",
                  "passingValue": false,
                  "condition": "isMobile",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "imageUrl",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "promoPrimaryModule",
      "name": "module",
      "storageKey": "module(type:\"promoPrimary\")",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "promoPrimary",
          "type": "String!"
        }
      ],
      "concreteType": null,
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "PromoModule",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "totalItemsCount",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '622dedf7b6ad042a5752d120a36c902a';
module.exports = node;
